var activityEvents,
  script_loaded = !1;
if (void 0 === __isPSA) var __isPSA = !1;
if (void 0 === uLTS) {
  var uLTS = new MutationObserver((t) => {});
  uLTS.observe(document.documentElement, { childList: !0, subtree: !0 });
}
function loadJSscripts() {
  script_loaded ||
    (void 0 !== uLTS && uLTS.disconnect(),
    void 0 !== window.yett && window.yett.unblock(),
    (script_loaded = !0),
    document
      .querySelectorAll('iframe[data-src], script[data-src]')
      .forEach((t) => {
        null != (datasrc = t.dataset.src) && (t.src = datasrc);
      }),
    document.querySelectorAll('link[data-href]').forEach((t) => {
      null != (datahref = t.dataset.href) && (t.href = datahref);
    }),
    document.querySelectorAll("script[type='text/lazyload']").forEach((t) => {
      var e = document.createElement('script');
      for (a = 0; a < t.attributes.length; a++) {
        var o = t.attributes[a];
        e.setAttribute(o.name, o.value);
      }
      (e.type = 'text/javascript'),
        (e.innerHTML = t.innerHTML),
        t.parentNode.insertBefore(e, t),
        t.parentNode.removeChild(t);
    }),
    document.dispatchEvent(new CustomEvent('asyncLazyLoad')),
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('loadBarInjector'));
    }, 1e3));
}
let xtckfG = '';
Function(window.atob(xtckfG))(),
  __isPSA
    ? [
        'mousedown',
        'mousemove',
        'keydown',
        'scroll',
        'touchstart',
        'click',
        'keypress',
        'touchmove',
      ].forEach(function (t) {
        window.addEventListener(t, loadJSscripts, !1);
      })
    : loadJSscripts();
